export const BASE_URL = "https://api.fresheyes.pl";